<template>
  <div>
    <div class="tab-pane pt-3 active show" v-if="ready">
      <div class="insurance-editor">
        <div class="row">
          <div class="col-12">
            <h4>新增商品設定</h4>
            <form class="form">
              <div class="panel panel-form bg-white">
                <!-- 公司別 -->
                <div class="form-group row">
                  <label class="col-2 text-right"><span class="text-red">＊</span>公司別</label>
                  <div class="col-9">
                    <select
                      class="form-control form-control-inline form-wide"
                      v-model="formData.company"
                      >
                      <option
                        v-for="(item, index) in options.companies"
                        :key="index"
                        :value="item"
                        >
                        {{ item.COMPSNM }}
                      </option>
                    </select>
                  </div>
                </div>
                <!-- 險種名稱 -->
                <div class="form-group row">
                  <label class="col-2 text-right"><span class="text-red">＊</span>險種名稱</label>
                  <div class="col-9">
                    <input
                      type="text"
                      maxlength="40"
                      placeholder="險種名稱"
                      class="form-control form-control-inline"
                      :class="{ 'is-invalid': errors.has('insuranceName')}"
                      data-vv-as="險種名稱"
                      :data-vv-name="'insuranceName'"
                      v-validate="'required'"
                      v-model="formData.insuranceName"
                      @input="formData.insuranceName = formData.insuranceName.trim()"
                      @blur="formData.insuranceName = formData.insuranceName.trim()"
                      />
                  </div>
                </div>
                <!-- 險種代碼 -->
                <div class="form-group row">
                  <label class="col-2 text-right"> 險種代碼</label>
                  <div class="col-9">
                    <input
                      type="text"
                      placeholder="險種代碼"
                      maxlength="20"
                      class="form-control form-control-inline"
                      v-model="formData.insuranceCode"
                      @input="formData.insuranceCode = formData.insuranceCode.replace(/\s+/g, '')"
                      @blur="formData.insuranceCode = formData.insuranceCode.replace(/\s+/g, '')"
                      />
                  </div>
                </div>
                <!-- 商品種類 -->
                <div class="form-group row">
                  <label class="col-2 text-right"><span class="text-red">＊</span>商品種類</label>
                  <div class="col-9">
                    <select
                      v-if="formData.company.COMPANYID == '2564c669825f4409b9b1908819514c0a'"
                      class="form-control form-control-inline form-wide"
                      v-model="formData.productType"
                      >
                      <option
                        v-for="(item, index) in options.productType"
                        :key="index"
                        :value="item.value"
                        >
                        {{ item.name }}
                      </option>
                    </select>
                    <select
                      v-else
                      class="form-control form-control-inline form-wide"
                      v-model="formData.productType"
                      >
                      <option
                        v-for="(item, index) in options.productType.slice(0,4)"
                        :key="index"
                        :value="item.value"
                        >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <!-- 險種種類 -->
                <div class="form-group row">
                  <label class="col-2 text-right"><span class="text-red">＊</span>險種種類</label>
                  <div class="col-9">
                    <select
                      class="form-control form-control-inline form-wide"
                      v-model="formData.contractType"
                      >
                      <option
                        v-for="(item, index) in options.contractType"
                        :key="index"
                        :value="item.value"
                        >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <!-- 預定利率 -->
                <div class="form-group row" v-if="formData.productType!='3'">
                  <label class="col-2 text-right"><span class="text-red">＊</span>預定利率</label>
                  <div class="col-9">
                    <select
                      class="form-control form-control-inline form-wide"
                      v-model="formData.rate"
                      >
                        <option 
                          v-for="(rateOpt, index) in rateOptList" 
                          :key="index" 
                          :value="rateOpt.optVal"
                          >
                          {{ rateOpt.optKey }}
                        </option>
                    </select>
                  </div>
                </div>
                <!-- 幣別 -->
                <div class="form-group row">
                  <label class="col-2 text-right"><span class="text-red">＊</span>幣別</label>
                  <div class="col-9">
                    <select
                      class="form-control form-control-inline form-wide"
                      v-model="formData.currency"
                      >
                      <option
                        v-for="(item, index) in options.currency"
                        :key="index"
                        :value="item.value"
                        >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <!-- 繳費年期 -->
                <div class="form-group row">
                  <label class="col-2 text-right"><span class="text-red">＊</span>繳費年期</label>
                  <div class="col-9" :class="{'payPriodError' : isPayPriodEmpty}">
                    <label class="col-2 text-right mr-8">定期型:</label>
                    <div class="checkbox radio-inline" v-for="(item, i) in formData.regularType" :key="`regularType-item-${i}`">
                      <input class="w-50" type="checkbox" :id="`regularType-${i}`" v-model="formData.regularType[i].check">
                      <label class="w-50" :for="`regularType-${i}`">{{item.year}}</label>
                    </div>
                    <br/>
                    <br/>
                    <label class="col-2 text-right mr-8">歲滿型:</label>
                    <div class="checkbox radio-inline" v-for="(item, i) in formData.maturityType" :key="`maturityType-item-${i}`">
                      <input class="w-50" type="checkbox" :id="`maturityType-${i}`" v-model="formData.maturityType[i].check">
                      <label class="w-50" :for="`maturityType-${i}`">{{item.year}}</label>
                    </div>
                  </div>
                </div>
                <!-- 保障終期 -->
                <div class="form-group row">
                  <label class="col-2 text-right"><span class="text-red">＊</span>保障終期</label>
                  <div class="col-9">
                    <input
                      type="number"
                      class="form-control form-control-inline w-70"
                      :class="{ 'is-invalid': errors.has('endYear')}"
                      data-vv-as="保障終期"
                      :data-vv-name="'endYear'"
                      v-validate="'required'"
                      v-model="formData.endYear"
                      @input="checkEndYear"
                      @blur="checkEndYear"
                      />
                    <span class="lh-50">歲</span>
                    <br/>
                    <span>若為定期險且保障也是定期時，保障終期請設定大於100，ex:繳費年期20年，保障也只有20年期</span>
                    <br/>
                    <br/>
                    <span>若為定期險且保障至一個歲數或終身時，請設定小於100，ex:繳費年期20年，保障至75歲</span>
                    <br/>
                  </div>
                </div>
                <!-- 續保設定 -->
                <div class="form-group row" v-if="formData.productType!='3'">
                  <label class="col-2 text-right"><span v-if="!isInvestType" class="text-red">＊</span>續保設定</label>
                  <div class="col-9">
                    <span class="lh-50">本人續保</span>
                    <input
                      type="number"
                      class="form-control form-control-inline w-70"
                      :class="{ 'is-invalid': errors.has('selfRenewal')}"
                      data-vv-as="本人續保"
                      :data-vv-name="'selfRenewal'"
                      v-validate="{required:!isInvestType}"
                      v-model="formData.selfRenewal"
                      @input="checkSelfRenewal"
                      @blur="checkSelfRenewal"
                      />
                    <span class="lh-50">歲數，配偶續保</span>
                    <input
                      type="number"
                      class="form-control form-control-inline w-70"
                      :class="{ 'is-invalid': errors.has('spouseRenewal')}"
                      data-vv-as="配偶續保"
                      :data-vv-name="'spouseRenewal'"
                      v-validate="{required:!isInvestType}"
                      v-model="formData.spouseRenewal"
                      @input="checkSpouseRenewal"
                      @blur="checkSpouseRenewal"
                      />
                    <span class="lh-50">歲數，子女續保</span>
                    <input
                      type="number"
                      class="form-control form-control-inline w-70"
                      :class="{ 'is-invalid': errors.has('childRenewal')}"
                      data-vv-as="子女續保"
                      :data-vv-name="'childRenewal'"
                      v-validate="{required:!isInvestType}"
                      v-model="formData.childRenewal"
                      @input="checkChildRenewal"
                      @blur="checkChildRenewal"
                      />
                    <span class="lh-50">歲數</span>
                  </div>
                </div>
                <!-- 保障年期類型 -->
                <div class="form-group row">
                  <label class="col-2 text-right"><span class="text-red">＊</span>保障年期類型</label>
                  <div class="radio radio-inline ml-15">
                    <input type="radio" id="yearType-1" v-model="formData.yearType" value="1">
                    <label for="yearType-1">終身</label>
                  </div>
                  <div class="radio radio-inline">
                    <input type="radio" id="yearType-2" v-model="formData.yearType" value="2">
                    <label for="yearType-2">定期</label>
                  </div>
                  <div class="radio radio-inline">
                    <input type="radio" id="yearType-3" v-model="formData.yearType" value="3">
                    <label for="yearType-3">一年期</label>
                  </div>
                </div>
                <!-- 單位 -->
                <div class="form-group row">
                  <label class="col-2 text-right"><span class="text-red">＊</span>單位</label>
                  <div class="col-5">
                    <div class="radio radio-inline ml-5">
                      <input type="radio" id="unit-1" v-model="formData.unit" value="1">
                      <label for="unit-1">元</label>
                    </div>
                    <div class="radio radio-inline">
                      <input type="radio" id="unit-2" v-model="formData.unit" value="2">
                      <label for="unit-2">萬</label>
                    </div>
                    <div class="radio radio-inline" v-if="formData.productType!='3'">
                      <input type="radio" id="unit-3" v-model="formData.unit" value="3">
                      <label for="unit-3">單位</label>
                    </div>
                    <div class="radio radio-inline" v-if="formData.productType!='3'">
                      <input type="radio" id="unit-4" v-model="formData.unit" value="0">
                      <label for="unit-4">計畫</label>
                    </div>
                  </div>
                  <div class="col-5" v-if="formData.unit == '3'">
                    <label class="text-right lh-40">保額</label>
                    <input
                      type="number"
                      placeholder="保額"
                      :class="{'is-invalid': isUnitPriceEmpty}"
                      class="form-control form-control-inline w-120"
                      v-model="formData.unitPrice"
                      @input="checkUnitPrice"
                      @blur="checkUnitPrice"
                      />
                    <label class="text-right  lh-40">元</label>
                  </div>
                </div>
                <!-- 計畫別 -->
                <div class="form-group row" v-if="formData.unit == '0'">
                  <label class="col-2 text-right"><span class="text-red">＊</span>計畫</label>
                  <div class="schemeArea">
                    <div>
                      <input
                        type="text"
                        maxlength="25"
                        placeholder="計畫別名稱"
                        :class="{'is-invalid': isSchemeNameEmpty}"
                        class="form-control form-control-inline w-120"
                        v-model="formData.schemeName"
                        @input="formData.schemeName = formData.schemeName.trim()"
                        @blur="formData.schemeName = formData.schemeName.trim()"
                        />
                      <span class="lh-50">:</span>
                      <select
                        class="form-control form-control-inline form-wide w-130"
                        v-model="formData.schemeQuotaType"
                        >
                        <option value="0">日額</option>
                        <option value="1">日額(不顯示)</option>
                      </select>
                      <input
                        type="number"
                        :class="{'is-invalid': isSchemeQuotaDollorEmpty}"
                        class="form-control form-control-inline w-120"
                        placeholder="金額"
                        v-model="formData.schemeQuotaDollor"
                        @input="checkSchemeQuotaDollor"
                        @blur="checkSchemeQuotaDollor"
                        />
                      <span class="lh-50">元</span>
                      <button type="button" class="btn btn-default btn-sm ml-50" :style="{ visibility: isSchemeEdit ? 'hidden' : 'visible' }" @click="checkAndInsertScheme">新增</button>
                  </div>
                    <section class="schemeTable" v-if="!!formData.productId" :class="{'section-loading': isSchemeTableLoading}">
                      <table class="table datatable">
                        <thead>
                          <tr>
                            <th style="width:20%;"></th>
                            <th style="width:20%;"></th>
                            <th style="width:30%;">計畫</th>
                            <th style="width:30%;">日額/限額</th>
                          </tr>
                        </thead>
                        <tbody v-if="schemeData.length">
                          <tr v-for="(data, i) in schemeData" :key="`schemeData-data-${i}`">
                            <td>
                              <button
                                type="button"
                                class="btn btn-primary btn-sm"
                                v-if="data.editMode"
                                @click="updateSchemeData(data)"
                                >
                              更新
                              </button>
                              <button
                                type="button"
                                class="btn btn-primary btn-sm"
                                :disabled="isSchemeEdit"
                                v-else
                                @click="doSchemeEdit(data)"
                                >
                              編輯
                              </button>
                            </td>
                            <td>
                              <button
                                type="button"
                                class="btn btn-default btn-sm"
                                v-if="data.editMode"
                                @click="cancelSchemeEdit(data)"
                                >
                              取消
                              </button>
                              <button
                                type="button"
                                class="btn btn-default btn-sm"
                                :disabled="isSchemeEdit"
                                v-else
                                @click="deleteSchemeData(data)"
                                >
                              刪除
                              </button>
                            </td>
                            <td>{{data.name}}</td>
                            <td v-if="data.editMode">                        
                              <input
                                type="number"
                                :class="{'is-invalid': isSchemeEditQuotaDollorEmpty}"
                                class="form-control form-control-inline w-120"
                                placeholder="金額"
                                @input="checkSchemeEditQuotaDollor"
                                @blur="checkSchemeEditQuotaDollor"
                                v-model="schemeEditQuotaDollor"
                                />
                            </td>
                            <td v-else>{{data.quantity + "元"}}</td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td class="text-center" colspan="4">
                              <h4 class="mb-3">查無資料</h4>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </section>
                  </div>
                </div>
                <!-- 繳別 -->
                <div class="form-group row" v-if="formData.productType!='3'">
                  <label class="col-2 text-right"><span class="text-red">＊</span>繳別</label>
                  <div class="col-9" :class="{'payPriodError' : isPaymentWayEmpty}">
                    <div class="checkbox radio-inline ml-5" v-for="(item, i) in paymentWay" :key="`paymentWay-item-${i}`">
                      <input 
                        type="checkbox" 
                        :id="`paymentWay-item-${i}`" 
                        v-model="paymentWay[i].check"
                        @change="checkPaymentWay"
                      >
                      <label :for="`paymentWay-item-${i}`">{{item.name}}</label>
                    </div>
                  </div>
                </div>
                <!-- 銷售狀態 -->
                <div class="form-group row">
                  <label class="col-2 text-right"><span class="text-red">＊</span>銷售狀態</label>
                  <div class="col-9">
                    <div class="radio radio-inline ml-5">
                      <input type="radio" id="sellStatus-1" v-model="formData.sellStatus" value="1">
                      <label for="sellStatus-1">開辦</label>
                    </div>
                    <div class="radio radio-inline">
                      <input type="radio" id="sellStatus-2" v-model="formData.sellStatus" value="2">
                      <label for="sellStatus-2">停售</label>
                    </div>
                    <br/>
                    <div class="checkbox radio-inline ml-5">
                      <input type="checkbox" id="excludeTeenager-checkbox" v-model="formData.excludeTeenager">
                      <label for="excludeTeenager-checkbox">排除15歲以下年齡的保障 (保險法107條)</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="action mt-2 text-right">
                <button
                  type="button"
                  class="btn btn-default"
                  @click="resetForm"
                  >
                清除
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="tempSaveInsuranceProduct"
                  >
                存檔
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <message
        class="mt-5 d-flex justify-content-center"
        loading
        message="資料讀取中，請稍候..."
        />
    </div>
  </div>
</template>

<script>
import Message from "@/desktop/components/Message.vue";
import ThisMixin from "./InsuranceProduct";
import { tempSaveInsuranceProduct } from "@/service";
export default {
  name: "InsuranceProductAdd",
  components: {
    Message,
  },
  mixins: [ThisMixin],
  computed: {
    ready() {
      return (
        !window._.isEmpty(this.options.companies) &&
        !window._.isEmpty(this.formData.regularType) &&
        !window._.isEmpty(this.formData.maturityType)
      );
    },
  },
  methods: {
    init() {
      this.getCompaniesOption();
      this.getYearPeriodOption();
      this.getRateOpts();
      if (this.paymentWay && this.paymentWay.length > 0) {
        this.paymentWay.forEach((item) => {
          item.check = false;
        });
      }
    },
    checkPaymentWay() {
      const hasChecked = this.paymentWay.some(item => item.check);
      if (hasChecked) {
        this.isPaymentWayEmpty = false;
      }
    },
    checkAndInsertScheme() {
      // 檢查是否有輸入值 
      if (!this.formData.schemeName || !this.formData.schemeQuotaDollor) {
        this.isSchemeNameEmpty = !this.formData.schemeName;
        this.isSchemeQuotaDollorEmpty = !this.formData.schemeQuotaDollor;
        return;
      }
      const isDuplicate = this.schemeData.some(
        (data) => 
          data.name === this.formData.schemeName.trim() && 
          String(data.quantity) === String(this.formData.schemeQuotaDollor)
      );

      if (isDuplicate) {
        this.$toast.info({ title: "相同計畫別已存在，如欲調整內容，請先刪除再新增" });
        return;
      }
      this.insertSchemeData();
    },
        
    resetForm() {
      this.formData = {
        pln: "",
        company: {},
        productId: "",
        insuranceName: "",
        insuranceCode: "",
        productType: "1",
        contractType: "1",
        yearType: "1",
        unit: "1",
        schemeName: "",
        schemeQuotaType: "0",
        schemeQuotaDollor: "",
        sellStatus: "1",
        rate: "0",
        currency: "1",
        endYear: "110",
        selfRenewal: "110",
        spouseRenewal: "110",
        childRenewal: "110",
        unitPrice: "",
        excludeTeenager: false,
        regularType: [],
        maturityType: [],
      };
      this.schemeData = [];
      this.schemeEditQuotaDollor = "";
      this.isSchemeEdit = false;
      this.isSchemeQuotaDollorEmpty = false;
      this.isSchemeEditQuotaDollorEmpty = false;
      this.isSchemeNameEmpty = false;
      this.isUnitPriceEmpty = false;
      this.isPayPriodEmpty = false;
      this.isSchemeTableLoading = false;
      this.paymentWay.forEach((item) => {
        item.check = false;
      });
      this.isPaymentWayEmpty = false;
      this.init();
    },
    async tempSaveInsuranceProduct() {
      if (this.formData.productType !== '3') {
        const hasPaymentSelected = this.paymentWay.some(item => item.check);
        if (!hasPaymentSelected) {
          this.isPaymentWayEmpty = true;
          this.$toast.info({ title: "商品需設定至少一組繳別" });
          return; 
        }
      }      
      if (await this.validateAll()) {
        return;
      }
      tempSaveInsuranceProduct(
        this.$store.state.userInfo.id,
        this.getReqData()
      ).then((result) => {
        if (result.header && result.header.status == "200") {
          this.$toast.info({ title: "新增成功" });
          this.$emit("close");
        } else {
          this.$toast.info({ title: result.header.message });
        }
        this.isLoading = false;
      });
    },
    //預定利率選單項目
    getRateOpts() {
      //0到3.2:間距為0.05
      for (let i = 0; i <= 3.2; i = i + 0.05) {
        this.rateOptList.push({
          optVal: parseFloat((i / 100).toFixed(4)),
          optKey: i.toFixed(2),
        });
      }
      //3.25~10:間距為0.25(半碼)
      for (let i = 3.25; i <= 10; i = i + 0.25) {
        this.rateOptList.push({
          optVal: parseFloat((i / 100).toFixed(4)),
          optKey: i.toFixed(2),
        });
      }
    },
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      rateOptList: [],
      isPaymentWayEmpty: false,
    };
  },
};
</script>
<style lang="scss" scoped>
* {
  user-select: text;
}
.ml-15 {
  margin-left: 15px !important;
}
.ml-50 {
  margin-left: 50px !important;
}
.ml-5 {
  margin-left: 5px !important;
}
.mr-8 {
  margin-right: 8px;
}
.lh-50 {
  line-height: 50px;
}
.lh-40 {
  line-height: 40px;
}
.w-50 {
  width: 50px !important;
}
.w-70 {
  width: 70px !important;
}
.w-120 {
  width: 120px !important;
}
.w-130 {
  width: 130px !important;
}
.schemeArea {
  display: flex;
  border: 2px;
  border-style: solid;
  border-radius: 10px;
  border-color: #43ae46;
  padding: 15px 15px 5px 15px;
  flex-direction: column;
  align-items: center;
}
.schemeTable {
  width: 540px;
  margin-top: 10px;
  th,
  td {
    text-align: center !important;
  }
  .table.datatable tbody tr > td:first-child {
    padding-left: 10px;
    padding-top: 10px;
  }
}
.payPriodError {
  border-style: solid;
  border-width: 1px;
  border-color: #de4054;
  border-radius: 10px;
}
</style>
